import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ClassesTab, InstructorDetails, Session } from 'src/app/models/meta';
import { ClassesService } from 'src/app/services/classes.service';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityService } from 'src/app/services/facility.service';
import { FacilityConfig } from 'src/environments/environment.interface';
import { Utils } from 'src/app/services/common/utils';

@Component({
  selector: 'df-booked-class',
  templateUrl: './booked-class.component.html',
  styleUrls: ['./booked-class.component.scss']
})
export class BookedClassComponent implements OnInit, OnDestroy {

  private readonly _unsubscribe: Subject<any> = new Subject();
  @Input()
  source: any = {};
  @Input()
  classesTab: ClassesTab = <ClassesTab>{};

  studioName: string = '';
  className: string = '';
  instructorName: string = '';
  studioLogo: string = '';

  startDate: string = '';
  startTime: string = '';
  facilityConfig: FacilityConfig = <FacilityConfig>{};

  constructor(
    private _classesService: ClassesService
    , private router: Router
    , private _environmentService: EnvironmentService
    , private facilityService: FacilityService
  ) {}

  async ngOnInit(): Promise<void> {
    this.facilityConfig = this._environmentService.getFacilityConfig();
    let session: Session | undefined = this.classesTab.Sessions.find(s => s.Id === this.source.SessionId);
    if (session) {
      let cl: any = this.classesTab.Classes.find(c => c.Id === session?.ClassId);
      let st: any = this.classesTab.Studios.find(s => s.Id === session?.StudioId);
      let ins: InstructorDetails | undefined = this.classesTab.Instructors.find(i => i.Id === session?.InstructorId);

      if (cl && st) {
        this.className = cl.Name;
        this.studioName = st.Name;
        this.studioLogo = st.Image.UploadedUrl;
        this.instructorName = ins?.Person?.FullName || '';
        let locations: { Id: number; TimeZone?: string }[] = [];
        try {
          locations = await this.facilityService.getLocations();
        } catch {
          locations = [];
        }
        const sessionTimeZone = Utils.resolveSessionTimeZoneFromLocations(
          st.LocationId,
          locations,
          this.facilityConfig?.timezone
        );
        const display = Utils.formatSessionDisplayParts(
          session.StartDate,
          session.StartTime,
          session.EndTime || session.StartTime,
          sessionTimeZone
        );
        this.startDate = `${display.month} ${display.dayOfMonth}`;
        this.startTime = display.timeZoneAbbr
          ? `${display.startTimeFull} ${display.timeZoneAbbr}`
          : display.startTimeFull;
      }
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }

  classStartDate(): string {
    return this.startDate;
  }

  classStartTime(): string {
    return this.startTime;
  }

  goToSession() {
    this.router.navigate(['studio', 'class-details', this.source.SessionId]);
  }

}
